import { PasswordResetActions } from '../actions/consts';

type PasswordResetState = {
  loading: boolean;
  errorMessage: string;
  successReset: boolean;
}

export function passwordReset(
  state = { loading: false, errorMessage: '', successReset: false } as PasswordResetState, action
) {
  switch (action.type) {
    case PasswordResetActions.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        errorMessage: '',
      };
    case PasswordResetActions.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case PasswordResetActions.LOAD_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.error.errorMessage,
      };
    case PasswordResetActions.LOAD_SEND_SUCCESS:
      return {
        ...state,
        successReset: true,
      };
    default:
      return state;
  }
}
